import { BaseContainerModel } from '../../base-container.model';
import { bl_fi_mst_attribute_set_attribute_link_RowClass } from '../../../dbschema/bl_fi_mst_attribute_set_attribute_link.model';
import { bl_fi_mst_attribute_set_ext_RowClass } from '../../../dbschema/bl_fi_mst_attribute_set_ext.model';

export class AttributeSetAttributeLinkContainerModel extends BaseContainerModel {
  bl_fi_mst_attribute_set_attribute_link: bl_fi_mst_attribute_set_attribute_link_RowClass = new bl_fi_mst_attribute_set_attribute_link_RowClass();
}